import React, {Component} from 'react';

class Cancellation_en_US extends Component {

    render() {

        // const tableStyle = {border: "1px solid black"};
        //
        // const tdStyle = {border: "1px solid black", padding: "0.5rem"};

        return (
            <div className="cancellation" dangerouslySetInnerHTML={{__html: this.props.content}}/>
        );
    }
}

// const mapStateToProps = (state) => (
// 	{
// 	}
// );

export default Cancellation_en_US;
